import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressStepsComponent } from './progress-steps/progress-steps.component';



@NgModule({
  declarations: [
    ProgressStepsComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ProgressStepsComponent
  ]
})
export class ProgressStepsModule { }
